// src/services/config.js

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:8080";

export default API_BASE_URL;
